import React, { useState } from 'react'
import { Dropdown, Tabs, Menu } from 'antd'

import { AiOutlineDown } from 'react-icons/ai'
import { BiSelectMultiple } from 'react-icons/bi'

import { normalize, server, stringifyDate, usePet, useToggle } from '../../modules'

import Modal from "../reusable/modal"
import Receive from '../reusable/receive'
import Elevated from './elevated'
import ApplyDiscountToItem from './applyDiscountToItem'
import Confirm from '../reusable/confirm'
import PrintIFrame from './printIFrame'
import ClaimStatusCard from '../reusable/claimStatusCard'
import PreauthStatusCard from '../reusable/preauthStatusCard'

const { TabPane } = Tabs

const OrderModal = ({ toggle, visible, order: ord, onPerform }) => {
    const [chosen, setChosen] = useState([])
    const [selected, setSelected] = useState()
    const [token, setToken] = useState()
    const [onSuccess, setOnSuccess] = useState(() => null)
    const [cancel, setCancel] = useState(false)

    const [select, toggleSelect] = useToggle()
    const [iframe, toggleIFrame] = useToggle()
    const [elevated, toggleElevated] = useToggle()
    const [discountModal, toggleDiscount] = useToggle()

    const [{ loading, error, data: order }, fetchOrder] = usePet('order', { id: ord?._id }, { notify: true })

    const togSelect = () => {
        setChosen([])
        toggleSelect()
    }

    const choose = id => {
        let temp = [...chosen]

        if (temp.includes(id)) {
            temp = temp.filter(x => x !== id)
        } else {
            temp.push(id)
        }

        setChosen(temp)
        console.log(chosen)
    }

    const onComplete = (_, notif, ops) => {
        notif('Bill has been split', ops('success'))
        onPerform()
        setTimeout(toggle, 300)
    }

    const [{ loading: sLoading }, split] = usePet('splitItemsFromBill', {
        parent: ord?._id,
        ids: chosen
    }, { notify: true, callback: onComplete, manual: true, load: { msg: 'Splitting items...' } })

    const [{ loading: rLoading }, remove] = usePet('removeItemFromBill', {
        parent: ord?._id,
        id: selected?._id,
    }, {
        notify: true, callback: (_, notif, ops) => {
            notif('Item has been removed', ops('success'))
            fetchOrder()
            onPerform()
        }, manual: true, load: { msg: 'Removing item...' }
    })

    const [{ loading: canLoading }, toggleCancel] = usePet('toggleCancelSingleItem', {
        id: selected?._id,
        reason: 'Refund single items'
    }, {
        notify: true, callback: (_, notif, ops) => {
            notif('Changes have beens aved', ops('success'))
            fetchOrder()
            onPerform()
        }, manual: true, load: { msg: 'Just a minute...' }
    })

    const [{ loading: refLoading }, refund] = usePet('toggleCancel', {
        id: ord?._id,
        items: chosen,
        cancel,
        reason: 'Refund single items'
    }, {
        notify: true, callback: (_, notif, ops) => {
            notif('Item has been refunded', ops('success'))
            fetchOrder()
            onPerform()
        }, manual: true, load: { msg: 'Recording refund...' }
    })

    const [{ loading: capLoading }, reprintCaptainOrders] = usePet('reprintCaptainOrders', {
        bill: ord?._id,
        items: chosen,
        targets: localStorage
    }, {
        notify: true,
        callback: (_, notif, ops) => notif('Request has been sent', ops('success')),
        manual: true,
        load: { msg: 'Sending Request...' }
    })

    const [{ loading: rdLoading }, revokeDiscount] = usePet('revokeItemDiscount', {
        id: selected?._id
    }, {
        notify: true, callback: (_, notif, ops) => {
            notif('Item has been removed', ops('success'))
            fetchOrder()
            onPerform()
        }, manual: true, load: { msg: 'Removing item...' }
    })

    const discount = ord => {
        setSelected(ord)
        toggleDiscount()
    }

    const elevate = fn => {
        setOnSuccess({ fn, setToken })
        setTimeout(toggleElevated, 200)
    }

    return (
        <Modal
            w={ 800 }
            toggle={ toggle }
            centered={ false }
            visible={ visible }
            title={`${ord?.patient?.name}'s Bill`}>
            {
                iframe &&
                <PrintIFrame
                    content="receipt"
                    visible={iframe}
                    id={ord?._id}
                    toggle={toggleIFrame}
                    title={`Bill #${ord?.orderNo}`} />
            }
            {
                elevated &&
                <Elevated
                    onSuccess={onSuccess}
                    toggle={toggleElevated}
                    visible={elevated} />
            }
            {
                discountModal &&
                <ApplyDiscountToItem
                    token={token}
                    item={selected}
                    onPerform={fetchOrder}
                    toggle={toggleDiscount}
                    visible={discountModal} />
            }
            <Receive
                loading={loading}
                error={error}>
                <Tabs defaultActiveKey="1">
                    <TabPane tab="Items" key="1">
                        <span className="flex justify-end">
                            {
                                chosen.length > 0 ?
                                    <Dropdown
                                        overlay={
                                            <Menu>
                                                <Menu.Item onClick={togSelect}>Deselect All</Menu.Item>
                                                {
                                                    order?.items?.length !== chosen.length ?
                                                        !order?.closed ?
                                                            <Menu.Item onClick={() => Confirm({
                                                                title: 'Split the Selected Items',
                                                                message: `This will remove the selected items from this bill and add them to a new bill`,
                                                                okText: 'Split items',
                                                                onOk: split
                                                            })}>Split the Selected Items</Menu.Item>
                                                            :
                                                            <>
                                                                <Menu.Item onClick={() => elevate(() => {
                                                                    setCancel(false)
                                                                    Confirm({
                                                                        title: 'Refund the Selected Items',
                                                                        message: `This will refund the selected items`,
                                                                        okText: 'Refund items',
                                                                        onOk: refund
                                                                    })
                                                                })}>Refund the Selected Items</Menu.Item>
                                                                <Menu.Item onClick={() => elevate(() => {
                                                                    setCancel(true)
                                                                    Confirm({
                                                                        title: 'Refund the Selected Items',
                                                                        message: `This will refund the selected items`,
                                                                        okText: 'Refund items',
                                                                        onOk: refund
                                                                    })
                                                                })}>Refund and Cancel</Menu.Item>
                                                            </>
                                                        : null
                                                }
                                            </Menu>
                                        }>
                                        <button className="btn mb-3 hisani-btn-green-light text-white">
                                            <span className="hidden xs:block mr-2">Actions ({chosen.length})</span>
                                            <AiOutlineDown />
                                        </button>
                                    </Dropdown>
                                    : order?.items?.length > 1 ?
                                        <button onClick={togSelect} className="btn mb-3 hisani-btn-green-light text-white">
                                            <BiSelectMultiple style={{ color: "white" }} />
                                            <span className="hidden xs:block ml-2">{!select ? "Select" : "Deselect All"}</span>
                                        </button>
                                        : null
                            }
                        </span>
                        <table className="table-auto w-full">
                            {/* Table header */}
                            <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                <tr>
                                    <th className="p-2">
                                        <div className="font-semibold text-left">No</div>
                                    </th>
                                    <th className="p-2">
                                        <div className="font-semibold text-left">Item</div>
                                    </th>
                                    {/* <th className="p-2">
                                        <div className="font-semibold text-left">Station</div>
                                    </th> */}
                                    <th className="p-2">
                                        <div className="font-semibold text-left">Unit Price</div>
                                    </th>
                                    <th className="p-2">
                                        <div className="font-semibold text-left">Discount</div>
                                    </th>
                                    <th className="p-2">
                                        <div className="font-semibold text-left">VAT</div>
                                    </th>
                                    <th className="p-2">
                                        <div className="font-semibold text-left">Total</div>
                                    </th>
                                    <th className="p-2">
                                        <div className="font-semibold text-left"></div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody className="text-sm font-medium divide-y divide-gray-100">
                                {
                                    order?.items?.map((item, key) =>
                                        <tr>
                                            <td className="p-2">
                                                <div className="text-center">
                                                    {
                                                        select && item?.ref?.type !== 'Compounded Item' && !order.closed ?
                                                            <input
                                                                onChange={() => choose(item._id)}
                                                                checked={chosen.includes(item._id)}
                                                                type="checkbox"
                                                                className="form-checkbox cursor-pointer h-5 w-5" />
                                                            : `${key + 1}.`
                                                    }
                                                </div>
                                            </td>
                                            <td className="p-2">
                                                <div className={`text-left ${item.cancelled ? 'line-through' : ''}`}>{item?.ref?.name ?? item?.name}</div>
                                            </td>
                                            {/* <td className="p-2 text-left">
                                                <div className="text-left">{item.destination.name}</div>
                                            </td> */}
                                            <td className="p-2 text-left">
                                                <div className={`text-left ${item.cancelled ? 'line-through' : ''}`}>Ksh. {item.unitPrice} X {item.quantity}</div>
                                            </td>
                                            <td className="p-2 text-left">
                                                <div className={`text-left ${item.cancelled ? 'line-through' : ''}`}>Ksh. {item?.discount ?? '0'}</div>
                                            </td>
                                            <td className="p-2 text-left">
                                                <div className={`text-left ${item.cancelled ? 'line-through' : ''}`}>Ksh. {(item?.unitPrice - (item?.discount ?? 0)) * ((item?.taxRate ?? 0) / 100)}</div>
                                            </td>
                                            <td className="p-2 text-left">
                                                <div className={`text-left ${item.cancelled ? 'line-through' : ''}`}>Ksh. {item?.quantity * (item?.unitPrice - (item?.discount ?? 0))}</div>
                                            </td>
                                            {
                                                !order?.waived &&
                                                <td className="p-2">
                                                    <Dropdown
                                                        overlay={
                                                            <Menu>
                                                                {
                                                                    order?.closed ?
                                                                        <Menu.Item
                                                                            onClick={() => elevate(() => {
                                                                                setSelected(item)

                                                                                Confirm({
                                                                                    title: item?.cancelled ? 'Restore this item' : 'Cancel this item',
                                                                                    message: `This will ${item?.cancelled ? 'restore' : 'cancel'} the selected item`,
                                                                                    okText: item?.cancelled ? 'Restore Item' : 'Cancel Item',
                                                                                    onOk: toggleCancel
                                                                                })
                                                                            })}>
                                                                            {item?.cancelled ? 'Restore Item' : 'Cancel Item'}
                                                                        </Menu.Item>
                                                                        : !order?.closed && !order?.waived &&
                                                                        <>
                                                                            <Menu.Item onClick={() => elevate(() => {
                                                                                if (!item.discount) {
                                                                                    discount(item)
                                                                                    return
                                                                                }
                                                                                setSelected(item)

                                                                                Confirm({
                                                                                    title: 'Remove item from bill',
                                                                                    message: `This will remove the selected item`,
                                                                                    okText: 'Remove item',
                                                                                    onOk: remove
                                                                                })
                                                                            })}>Remove Item</Menu.Item>
                                                                            <Menu.Item onClick={() => elevate(() => {
                                                                                if (!item.discount) {
                                                                                    discount(item)
                                                                                    return
                                                                                }
                                                                                setSelected(item)

                                                                                Confirm({
                                                                                    title: 'Revoke discount',
                                                                                    message: `This will remove the applied discount of Ksh. ${item.discount}`,
                                                                                    okText: 'Revoke Discount',
                                                                                    onOk: revokeDiscount
                                                                                })
                                                                            })}>{item.discount ? `Revoke Discount (Ksh. ${item.discount})` : 'Apply Discount'}</Menu.Item>
                                                                        </>
                                                                }
                                                            </Menu>
                                                        }>
                                                        <a className="ant-dropdown-link flex items-center h-10" onClick={e => e.preventDefault()}><span className="mr-2">Actions</span> <AiOutlineDown /></a>
                                                    </Dropdown>
                                                </td>
                                            }
                                        </tr>
                                    )
                                }
                            </tbody>
                        </table>
                        <div className="flex flex-col items-end pr-3 py-3">
                            <p className="font-semibold text-lg underline mb-2">Overview</p>
                            <p className="mb-1">Discount: Ksh. {normalize(order?.items?.filter(itm => !itm.cancelled)?.reduce((total, itm) => total + (itm?.discount ?? 0), 0))}</p>
                            <p className="mb-1">Before Tax: Ksh. {normalize(order?.items?.filter(itm => !itm.cancelled)?.reduce((total, itm) => total + ((itm?.unitPrice - (itm?.discount ?? 0)) * itm?.quantity * ((100 - itm?.taxRate) / 100)), 0))}</p>
                            <p className="mb-1">VAT: Ksh. {normalize(order?.items?.filter(itm => !itm.cancelled)?.reduce((total, itm) => total + (((itm?.unitPrice - (itm?.discount ?? 0)) * itm?.quantity) * (itm?.taxRate / 100)), 0))}</p>
                            <p className="mb-1">Total: Ksh. {normalize(order?.items?.filter(itm => !itm.cancelled)?.reduce((total, itm) => total + ((itm?.unitPrice - (itm?.discount ?? 0)) * itm?.quantity), 0) - (order?.discount ?? 0))}</p>
                        </div>
                    </TabPane>
                    <TabPane tab="Payments" key="2">
                        {
                            order?.payments?.length > 0 ?
                                <table className="table-auto w-full">
                                    {/* Table header */}
                                    <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                        <tr>
                                            <th className="p-2">
                                                <div className="font-semibold text-center">No</div>
                                            </th>
                                            <th className="p-2">
                                                <div className="font-semibold text-left">Method</div>
                                            </th>
                                            <th className="p-2">
                                                <div className="font-semibold text-center">Amount</div>
                                            </th>
                                            <th className="p-2">
                                                <div className="font-semibold text-center">Date</div>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody className="text-sm font-medium divide-y divide-gray-100">
                                        {
                                            order?.payments?.map((payment, key) =>
                                                <tr>
                                                    <td className="p-2">
                                                        <div className="text-center">{key + 1}.</div>
                                                    </td>
                                                    <td className="p-2">
                                                        {payment.method}
                                                        <p className="text-gray-500 text-xs italic">{payment.description}</p>
                                                    </td>
                                                    <td className="p-2 text-center">
                                                        <div className="text-center">Ksh. {Math.abs(payment.amount)}</div>
                                                    </td>
                                                    <td className="p-2 text-center">
                                                        <div className="text-center">{stringifyDate(payment.date)}</div>
                                                    </td>
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                </table>
                                :
                                <div className="w-full h-16 flex items-center justify-center">
                                    <p className="font-semibold text-base">No payments have been recorded for this bill</p>
                                </div>
                        }
                    </TabPane>
                    <TabPane tab="Details" key="3">
                        <h2 className="mt-2">Status</h2>
                        <p className={`${(order?.waived || order?.cancelled) ? 'text-red-400' : order?.closed ? 'text-green-500' : 'text-yellow-500'}`}>{order?.waived ? 'Waived' : order?.cancelled ? 'Cancelled' : order?.closed ? 'Closed' : 'Open'}</p>
                        <hr />
                        {
                            order?.closed ?
                                <>
                                    <h2 className="mt-2">Served By</h2>
                                    <p>{order?.closedBy?.name}</p>
                                    <hr />
                                </> : null
                        }
                        {
                            order?.cancelled ?
                                <>
                                    <h2 className="mt-2">Cancelled By</h2>
                                    <p>{order?.cancelledBy?.name}</p>
                                    <hr />
                                </> : null
                        }
                        {
                            order?.waived ?
                                <>
                                    <h2 className="mt-2">Waived By</h2>
                                    <p>{order?.waivedBy?.name}</p>
                                    <hr />
                                </> : null
                        }
                        {
                            order?.discount ?
                                <>
                                    <h2 className="mt-2">Discount</h2>
                                    <p>Amount: Ksh. {order?.discount}</p>
                                    <p>Authorized By {order?.discountedBy?.name}</p>
                                    <hr />
                                </> : null
                        }
                        {
                            order?.complementary ?
                                <>
                                    <h2 className="mt-2">Complementary</h2>
                                    <p>Amount: Ksh. {order?.complementary}</p>
                                    <p>Authorized By {order?.complementaryAuthBy?.name}</p>
                                    <hr />
                                </> : null
                        }
                        {
                            order?.shelved && !order?.closed ?
                                <>
                                    <h2 className="mt-2">Shelved By</h2>
                                    <p>{order?.shelvedBy?.name}</p>
                                    <hr />
                                </> : null
                        }
                        {
                            order?.notes ?
                                <>
                                    <h2 className="mt-2">Notes</h2>
                            <p style={{ wordWrap: 'unset' }}>{order?.notes}</p>
                                </> : null
                        }
                    </TabPane>
                    <TabPane tab="SHA Claim" key="4">
                        <ClaimStatusCard orderId={ order?._id } />
                        <PreauthStatusCard orderId={ order?._id } />
                    </TabPane>
                </Tabs>
            </Receive>
            <div className="flex mt-2 justify-end">
                <button onClick={toggle} className="px-4 rounded-md outline-none focus:ring-4 shadow-lg mr-4">Close</button>
                <button type="submit" onClick={toggleIFrame} className="text-white hisani-btn-green-light font-medium rounded-lg text-sm px-5 py-2.5 text-center">Print Bill</button>
            </div>
        </Modal>
    )
}

export default OrderModal
